import React from 'react';

import { isMobileView } from 'constants/isMobileView';

import { BottomDrawer, DrawerBody, DrawerContent, DrawerFooter, DrawerHeader } from 'uiToolkitV1/BottomDrawer';
import { Button } from 'uiToolkitV1/Button';
import { TextBodyMedium } from 'uiToolkitV1/Typography';

interface Props {
  open: boolean;
  onClose: () => void;
  heading: string;
  children: React.ReactNode;
  onSave: () => void;
  showFooter?: boolean;
}
const mobileViewProps = isMobileView() ? { marginLeft: '0px', marginRight: '0px' } : {};

const FeedbackBottomDrawer = ({ heading, open, children, onClose, onSave, showFooter = false }: Props) => (
  <BottomDrawer isOpen={open} onClose={onClose}>
    <DrawerContent {...mobileViewProps}>
      <DrawerHeader
        sx={{
          button: {
            zIndex: 2,
          },
        }}
        p={heading?.length ? '24px !important' : '0px'}
        onClose={onClose}
      >
        <TextBodyMedium bold>{heading}</TextBodyMedium>
      </DrawerHeader>
      <DrawerBody borderRadius={heading?.length ? '0px' : '8px 8px 0px 0px'}>{children}</DrawerBody>
      {showFooter && (
        <DrawerFooter>
          <Button variant="outlined" mr={4} onClick={onClose}>
            Cancel
          </Button>
          <Button variant="filled" colorScheme="blue" onClick={onSave} disabled={false}>
            Submit
          </Button>
        </DrawerFooter>
      )}
    </DrawerContent>
  </BottomDrawer>
);

export default FeedbackBottomDrawer;
